import { ChangeDetectorRef ,ViewRef,Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { Stringable, StringableValues } from '../../../../../common/stringable.decorator'
import { FormDialogFormulaireWithSFComponent } from '../../../../../motor-form-atyl/form-atyl-components/form-dialog/form-dialog-formulaire-with-sf/form-dialog-formulaire-with-sf.component'
import { JSONRpcResponse } from '../../../../../Interfaces/JSONRpcResponse'
import { DialogService, StateService,DossierService

 } from '../../../../../services'

 
 


import {
	Observable,
	BehaviorSubject,	
} from "rxjs";

import { saveAs } from 'file-saver';

const KEY = 'dossier-action'

@Component({
  selector: 'atyl-dossier-action',
  templateUrl: './dossier-action.component.html',
  styleUrls: ['./dossier-action.component.scss']
})
@Stringable({
  path: 'views/partials/content/dossier/dossier-action',
  key: KEY,
})
export class DossierActionComponent implements OnInit {

  @Input() refresh:BehaviorSubject<number>=new BehaviorSubject<number>(0);
  
  loading:boolean=false;
  
  @StringableValues(KEY) strings: any
  
  @Input() inline:boolean =true;
  @Input() tiers: any;
  @Input() dossier: any;
  @Input() donnee: any;
  
  private action:any={};
  
  stats:any[]=[];
  
  refreshEvent:any;

  constructor(
    private changeDetector: ChangeDetectorRef,
    private stateService: StateService,
    private dialogService: DialogService,
    private dossierService: DossierService,
    private changeDetectorRef: ChangeDetectorRef
  
  ) { }

  ngOnInit() {
	  
	  if (this.donnee!=undefined && this.donnee.defaut!=undefined && this.donnee.defaut.action!=undefined)
		this.action=this.donnee.defaut.action;
	  
	  console.log("DossierActionComponent init",this.dossier,this.tiers,this.donnee,this.action);	
	  	  
	  this.refreshEvent=this.refresh.subscribe((ID)=>{
		console.log("DossierActionComponent refresh",this.tiers,ID)
		
				
		 });
	  
	 
    }
    
  
  
  ngOnDestroy() {
	if (this.refreshEvent) {
		console.log("DossierActionComponent destroy",this.refreshEvent,this.dossier,this.tiers,this.donnee);	
		  
		 
  		this.refreshEvent.unsubscribe();
  	}
        
   }
  
   
  
   detectChanges() {
        setTimeout(() => {
            if (this.changeDetectorRef && !(this.changeDetectorRef as ViewRef).destroyed) {
                this.changeDetectorRef.detectChanges()
            }
        })
    }
    
	changeBackground() {
		if (this.action!=undefined && this.action.color!=undefined)
			return { 'color': this.action.color };
		else
			return {};
	}
	
	clickAction() {
		if (this.action!=undefined && this.action.type!=undefined
			 && this.donnee!=undefined  && this.donnee.value!=undefined) {
			let type:string=this.action.type;
			
			if (type=="FSE"
				) {
				let filename="dossier_"+this._newGuid()+".xml"
				let xml:string='<?xml version="1.0" standalone="yes" ?>\n'+
				'<ACTION>\n'+
					'<Message>CHARGETRAITMENT</Message>\n'+
					'<IDDossier>'+this.donnee.value+'</IDDossier>\n'+
				'</ACTION>\n';

				var blob = new Blob([xml], {type: "text/xml;charset=utf-8"});
				saveAs(blob, filename);
				
			}
			
		}
	}
	
	private _newGuid() {
				return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
					var r = Math.random() * 16 | 0,
						v = c == 'x' ? r : (r & 0x3 | 0x8)
					return v.toString(16)
				})
			}

}
